module.exports = __webpack_public_path__ + "static/media/alejandro.3a9e3653.jpg";